import { Component, inject } from '@angular/core';
import { ChatRealtimeService } from './messages/chat-realtime.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  private chatRealtimeService = inject(ChatRealtimeService);
}
